var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './video-item.styles';
import { classMap } from 'lit/directives/class-map.js';
import '../badge/badge';
import '@mf-cms/helpers/src/dateFormatter';
import { dictionary } from '@mf-cms/helpers';
let PVideoItem = class PVideoItem extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'grid';
        this.headingTag = 'h3';
        this.culture = 'en-GB';
    }
    static { this.styles = styles; }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const nowDate = new Date();
        const publishedDate = new Date(this.date || nowDate);
        // const publishedDateMachineReadable = publishedDate.toISOString().split('T')[0];
        const publishedDateFormatted = publishedDate.format('MMMM dd, yyyy', { culture: 'en-GB' });
        const upcomingDateFormatted = publishedDate.format('MMMM dd', { culture: 'en-GB' });
        const upcomingDateTimeFormatted = publishedDate.format('hh:mm', { culture: 'en-GB' });
        let durationFormatted = '';
        if (this.duration) {
            durationFormatted = new Date(this.duration * 1000).toISOString().slice(11, 19);
            if (durationFormatted.startsWith('00:')) {
                durationFormatted = durationFormatted.slice(3);
            }
        }
        const classes = {
            [`${this.type}`]: true,
            live: this.isLive,
            upcoming: this.isUpcoming
        };
        const playSVG = html ` <svg class="play" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.6" /> <path d="M28.5 19.634C29.1667 20.0189 29.1667 20.9811 28.5 21.366L15.75 28.7272C15.0833 29.1121 14.25 28.631 14.25 27.8612L14.25 13.1388C14.25 12.369 15.0833 11.8879 15.75 12.2728L28.5 19.634Z" fill="white" /> </svg>`;
        let ariaLabel = '';
        if (this.heading) {
            ariaLabel += this.heading + '. ';
        }
        if (this.isUpcoming || this.isLive) {
            ariaLabel += `${dictionary(this.culture, 'videoItem', 'ariaStatus')} `;
            if (this.isUpcoming) {
                ariaLabel += `${dictionary(this.culture, 'videoItem', 'ariaUpcoming')} (${upcomingDateFormatted}, ${upcomingDateTimeFormatted})`;
            }
            else {
                ariaLabel += `${dictionary(this.culture, 'videoItem', 'ariaLive')}`;
            }
        }
        if (this.duration) {
            ariaLabel += `${dictionary(this.culture, 'videoItem', 'ariaDuration')} ${durationFormatted}`;
            ariaLabel += '. ';
        }
        let headingElement;
        if (this.heading) {
            if (this.headingTag == 'h2') {
                headingElement = html `<h2 class="title"> ${this.heading} ${this.dateInHeading ? ` - ${publishedDateFormatted}` : ''}
        </h2>`;
            }
            else {
                headingElement = html `<h3 class="title"> ${this.heading} ${this.dateInHeading ? ` - ${publishedDateFormatted}` : ''}
        </h3>`;
            }
        }
        return html ` <article class="video-item${classMap(classes)}"> <a href=${this.link} class="thumbnail-link" aria-label=${ariaLabel}> <figure class="thumbnail"> ${this.poster ? html `<img alt=${this.alt} src=${this.poster} />` : ''}
            ${this.isUpcoming
            ? html ` <div class="upcoming-overlay"> <p-badge class="upcoming-badge" color="dashed" dark >${dictionary(this.culture, 'videoItem', 'upcoming')}</p-badge > ${upcomingDateFormatted}<br /> ${upcomingDateTimeFormatted} </div> `
            : playSVG}
            ${this.isLive
            ? html `<p-badge class="live-badge" dark color="live" >${dictionary(this.culture, 'videoItem', 'live')}</p-badge >`
            : ''}
            ${this.ended
            ? html `<p-badge class="live-badge" >${dictionary(this.culture, 'videoItem', 'ended')}</p-badge >`
            : ''}
            ${this.duration
            ? html `<time class="duration" ><span class="sr-only" >${dictionary(this.culture, 'videoItem', 'ariaDuration')} </span >${durationFormatted}</time >`
            : ''}
          </figure>
          <div class="text-container">
            ${headingElement ? html `${headingElement}` : ''}
            ${this.summary ? html ` <p class="description">${this.summary}</p> ` : ''}
          </div>
        </a>
      </article>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "type", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "alt", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "duration", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "poster", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "date", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'date-in-heading' })
], PVideoItem.prototype, "dateInHeading", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "link", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "heading", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'heading-tag' })
], PVideoItem.prototype, "headingTag", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoItem.prototype, "summary", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'is-live' })
], PVideoItem.prototype, "isLive", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'is-upcoming' })
], PVideoItem.prototype, "isUpcoming", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PVideoItem.prototype, "ended", void 0);
__decorate([
    property({ type: String })
], PVideoItem.prototype, "culture", void 0);
PVideoItem = __decorate([
    customElement('p-video-item')
    /**
     * PVideoItem component
     *
     * @class PVideoItem
     * @typedef {PVideoItem}
     * @extends {LitElement}
     */
], PVideoItem);
export { PVideoItem };
